import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/insumo-selecionar";

export const Route = createFileRoute("/_authenticated/insumo-selecionar")({
  head: () => ({
    meta: [
      { title: "Selecionar insumo — Milky Moo Palmares" },
      { name: "description", content: "Busca e seleção de insumos por nome ou categoria." },
      { property: "og:title", content: "Selecionar insumo — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Busca e seleção de insumos por nome ou categoria.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
